import { useQuery } from '@tanstack/react-query';
import { rateApiService } from '@/services/rateApi.service';
import { useSalaryPassKey } from '@/hooks/payroll/useSalaryPassKey';

/**
 * One employee's rate periods, oldest first, read straight from the Rate API.
 *
 * Still gated on `unlocked` even though SalaryGate keeps the caller unmounted
 * until then: the typed pass key IS the credential, so a stray call before it is
 * entered can only collect a 401.
 *
 * A detail resource, so it follows the 5-minute stale time; the mutations
 * invalidate this key directly when a rate changes.
 */
export function useRateHistory(userId: string) {
  const { unlocked } = useSalaryPassKey();

  return useQuery({
    queryKey: ['rate-periods', userId],
    queryFn: () => rateApiService.getHistory(userId),
    enabled: unlocked && !!userId,
  });
}
